import { Component, Prop, Vue } from 'vue-property-decorator';
import { logout } from '../../auth';
import LoginInformation from '../../types/login_information';
import IconText from '../shared/iconText.vue';
import { Getter } from 'vuex-class';
import { ViewerContext } from '../../types/viewer_context';

@Component({ components: { IconText } })
export default class MainSideBar extends Vue {
  @Prop() public loginInformation!: LoginInformation;
  @Getter public viewerContext!: ViewerContext;

  get currentPage() {
    return this.$route.path;
  }

  get iconSrcUrl(): string {
    return `https://ui-avatars.com/api/?name=${this.loginInformation.displayName}`;
  }
  public logoutClicked() {
    logout();
  }
}
